import React from 'react';

import moment from 'moment';

import ApproversTable from '../user/ApproversTable';

import Button from 'CommonComponents/Button';
import FormHorizontalSeparator from 'CommonComponents/FormHorizontalSeparator';
import FormSectionHeading from 'CommonComponents/FormSectionHeading';
import FormTextRow from 'CommonComponents/FormTextRow';
import ModalHeader from 'CommonComponents/ModalHeader';

const EMPTY = '—';

const formatDate = (value) => {
    const date = moment(value);

    return value && date.isValid() ? date.format('DD/MM/YYYY') : EMPTY;
};

export default function PurchaseRequisitionsViewModal(props) {
    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Purchase Requisition Details')} close={props.closeHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        <div className="modal__form-container">
                            {Object.keys(props.pr).length > 0 && (
                                <>
                                    <FormTextRow label={$t('PR code') + ':'} text={props.pr.pr_code || EMPTY}></FormTextRow>

                                    <FormTextRow label={$t('Title') + ':'} text={props.pr.title || EMPTY}></FormTextRow>

                                    <FormTextRow label={$t('Requestor') + ':'} text={props.pr.opener_name || EMPTY}></FormTextRow>

                                    <FormTextRow label={$t('Estimated value') + ':'} text={props.pr.estimated_value ?? EMPTY}></FormTextRow>

                                    <FormTextRow label={$t('Procurement method') + ':'} text={props.pr.procurement_policy_method || EMPTY}></FormTextRow>

                                    <FormTextRow label={$t('Target contract date') + ':'} text={formatDate(props.pr.contract_date)}></FormTextRow>

                                    <FormTextRow
                                        label={$t('Status') + ':'}
                                        text={props.pr.canceled_at ? $t('Canceled') : props.pr.status || EMPTY}
                                    ></FormTextRow>

                                    <FormTextRow label={$t('Description') + ':'} text={props.pr.description || EMPTY} isPreTag={true}></FormTextRow>

                                    <FormHorizontalSeparator></FormHorizontalSeparator>

                                    <div className="tw-grid tw-grid-cols-1">
                                        <FormSectionHeading heading={$t('Approval History')}></FormSectionHeading>
                                    </div>
                                    <div className="table__card">
                                        <ApproversTable
                                            approvers={props.pr.approval_history || props.pr.approvers || []}
                                            status={props.pr.status}
                                            displayApprovalStatuses={props.displayApprovalStatuses}
                                        />
                                    </div>

                                    {!!props.openRecordUrl && (
                                        <div className="tw-grid tw-grid-cols-1">
                                            <a
                                                href={props.openRecordUrl}
                                                className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-blue hover:tw-underline"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {$t('Open PR in InBudget')}
                                            </a>
                                        </div>
                                    )}

                                    <div className="modal__footer">
                                        <Button variant="secondary" onClick={props.closeHandler}>
                                            {$t('Close')}
                                        </Button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
